import { Box, type SxProps, Typography } from '@mui/material'

interface DateEvent {
  title: string
  date?: Date
  startTime?: Date
  endTime?: Date
}

interface Props {
  event: DateEvent
  budgetRequestAmount?: number | null
  actualBudgetAmount?: number | null
  eventBoxStyle?: SxProps
  hideDateLine?: boolean
  description?: string
  seriesLetter?: string
}

export const EventDisplay = (props: Props): JSX.Element => {
  const getDateLine = (event: DateEvent): string => {
    if (event.date == null) {
      return 'This is a series of events'
    }

    let dateLine = new Date(event.date).toLocaleDateString([], { weekday: 'short', month: 'long', day: 'numeric', year: 'numeric' })
    if (event.startTime != null) {
      const startDate = new Date(event.startTime)
      dateLine += ` - ${startDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}`
    }
    if (event.endTime != null) {
      if (event.startTime != null) {
        dateLine += ' to '
      } else {
        dateLine += ' - '
      }
      const endDate = new Date(event.endTime)
      dateLine += endDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
    }
    return dateLine
  }

  const getShortMonth = (): string => {
    if (props.event.date == null) {
      return 'Series'
    }

    return new Date(props.event.date).toLocaleDateString([], { month: 'short' })
  }

  const getNumericDay = (): string => {
    if (props.event.date == null) {
      return props.seriesLetter ?? 'S'
    }

    return new Date(props.event.date).toLocaleDateString([], { day: 'numeric' })
  }

  return <Box sx={{ display: 'flex' }}>
    <Box sx={{ backgroundColor: 'var(--purple-500)', px: '.5em', py: '.125em', alignContent: 'center', borderRadius: '.25em', width: '1.5em', height: '2.25em', ...props.eventBoxStyle }}>
      <Typography variant='subtitle1' sx={{ color: 'white', fontWeight: 400, textAlign: 'center', lineHeight: 'normal' }}>{getShortMonth()}</Typography>
      <Typography variant='h4' sx={{ color: 'white', textAlign: 'center', lineHeight: 1 }}>{getNumericDay()}</Typography>
    </Box>

    <Box sx={{ ml: '1em', alignContent: 'center' }}>
      <Typography variant='h5'>{props.event.title}</Typography>
      {props.hideDateLine !== true && <Typography variant='body1'>{getDateLine(props.event)}</Typography>}
      {props.description != null && <Typography variant='body1'>{props.description}</Typography>}
      {props.budgetRequestAmount != null && (
        <Typography variant='body1'>Budget: ${props.budgetRequestAmount.toLocaleString()}</Typography>
      )}
    </Box>
  </Box>
}
